module.exports = __webpack_public_path__ + "images/emoji/metal.19a06afa1c2bf8f82f6f.png";